var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllProjects1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0999 17.3995L34.4665 24.3662C33.0665 30.3828 30.2999 32.8162 25.0999 32.3162C24.2665 32.2495 23.3665 32.0995 22.3999 31.8662L19.5999 31.1995C12.6499 29.5495 10.4999 26.1162 12.1332 19.1495L13.7665 12.1662C14.0999 10.7495 14.4999 9.51615 14.9999 8.49948C16.9499 4.46615 20.2665 3.38282 25.8332 4.69948L28.6165 5.34948C35.5999 6.98282 37.7332 10.4328 36.0999 17.3995Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0672 14.2156L29.1506 16.2656M19.4339 20.6656L24.2672 21.8989M25.1006 32.3156C24.0672 33.0156 22.7672 33.5989 21.1839 34.1156L18.5506 34.9822C11.9339 37.1156 8.45057 35.3322 6.30057 28.7156L4.16724 22.1322C2.0339 15.5156 3.80057 12.0156 10.4172 9.88223L13.0506 9.01557C13.7339 8.7989 14.3839 8.61557 15.0006 8.4989C14.5006 9.51557 14.1006 10.7489 13.7672 12.1656L12.1339 19.1489C10.5006 26.1156 12.6506 29.5489 19.6006 31.1989L22.4006 31.8656C23.3672 32.0989 24.2672 32.2489 25.1006 32.3156Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProjects1);
export default __webpack_public_path__ + "static/media/AllProjects1.0c38b286567a1726eb2eb8e759c05e20.svg";
export { ForwardRef as ReactComponent };